


































import {Component, Vue} from "vue-property-decorator";
import {Customer} from "@/entity/Customer";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {CustomerDto} from "@/dto/CustomerDto";
import {getModule} from "vuex-module-decorators";
import {CustomerStore} from "@/store/CustomerStore";
import CustomerAdminTable from "@/views/KeShangAdmin/CustomerAdminTable.vue";
import KeShangMain from "@/views/KeShangMain.vue";
import {AuthTokenDto} from "@/oauth/AuthTokenDto";
import {AuthStore} from "@/oauth/AuthStore";
import {CollectCompany} from "@/entity/CollectCompany";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";


@Component({
  components: {CustomerAdminTable, KeShangMain},
})

export default class XHeader extends Vue  {

  private customers: Customer[] = [];
  customer = new Customer();
  isAdminOpen = false;
  cs = getModule(CustomerStore);
  ls = getModule(AuthStore);
  su = SecurityUtils;
  rightDrawerOpen = true;
  drawer = false;
  tab = 'home';
  collectCompany = new CollectCompany()


  goToZiZhangHaoGuanLi() {
    this.$router.push({name: 'ZiZhangHao'});
  }

  get id() {
    return this.$route.params.id as string;
  }

  saveCompany() {
   localStorage.setItem("name", this.cs.currentCustomer.name)
  }

  companyName() {
    const item: string | null = localStorage.getItem("name");
    if (item == null) {
      return "home"
    }
    return item;
  }

  get userName(){
    return this.ls.loginUser.username
  }


  toggleRightDrawer() {
    this.rightDrawerOpen = !this.rightDrawerOpen;
  }




  async findAll() {
    const id = this.su.getLoginUser().id as number;
    const customer = new Customer();
    customer.creatorId = id;
    this.customers = await CustomerDto.findAll(customer);
    for (const value of this.su.getLoginUser().authorities) {
      if (value.authority.startsWith('ROLE_CUSTOMER_')) {
        const id = Number(value.authority.replace('ROLE_CUSTOMER_', '').replace('_ADMIN', ''));
        if (!this.customers.some(c => c.id === id)) {
          const customer = await CustomerDto.findById(id);
          if (typeof customer !== 'undefined') {
            this.customers.push(customer);
          }
        }
      }
    }
  }

  suc() {
    AuthTokenDto.logout();
    this.$router.push({name: 'login'});
  }

  handleClick(c: Customer) {
    getModule(CustomerStore).setCurrentCustomer(c);
    this.rightDrawerOpen = !this.rightDrawerOpen;

    this.saveCompany();
    // const id = c.id + '';
    // this.$router.push({name: 'KeShangMain', params: {id: id}});
  }

  // get customerName() {
  //   return this.cs.currentCustomer.name;
  // }

  async  findAllCompanyName(){
    const  id = this.su.getLoginUser().id as number;
    // const  collectName = new  CollectCompany();
    this.collectCompany = await  CollectCompanyDto.findById(id)
    console.log(this.collectCompany)
    // this.collectCompany.companyName = this.module.currentCustomer.name
  }

  get customerName() {

    // const  id = this.su.getLoginUser().id as number;
    // const  collectName = new  CollectCompany()
    // collectName.userId = id;
    // this.collectCompany  =  await CollectCompanyDto.findById( id)


    // return this.cs.currentCustomer.name;
    return this.collectCompany.companyName;
  }

  private mounted() {
    this.findAll()
    this.findAllCompanyName();
  }
}
